export const DASHBOARD_FILTER_STORAGE_KEY = "medicube:dashboard-filters:v1";

export type DashboardFilterState = {
  activeTab: "all" | "today" | "reminders" | "upload";
  autoClearFilters: boolean;
  clinician: string;
  consent: string;
  statusFilter: string;
  query: string;
  patientQuery: string;
  selectedPatientId: number | null;
};

const defaults: DashboardFilterState = {
  activeTab: "all",
  autoClearFilters: true,
  clinician: "all",
  consent: "all",
  statusFilter: "all",
  query: "",
  patientQuery: "",
  selectedPatientId: null,
};

// Keep navigation state within the current browser tab.
export function readDashboardFilters(): DashboardFilterState {
  try {
    const raw = window.sessionStorage.getItem(DASHBOARD_FILTER_STORAGE_KEY);
    if (!raw) return { ...defaults };
    const saved = JSON.parse(raw);
    if (!saved || typeof saved !== "object" || Array.isArray(saved)) return { ...defaults };
    const text = (key: "clinician" | "query" | "patientQuery") =>
      typeof saved[key] === "string" ? saved[key] : defaults[key];

    return {
      activeTab: ["all", "today", "reminders", "upload"].includes(saved.activeTab)
        ? saved.activeTab : defaults.activeTab,
      autoClearFilters: typeof saved.autoClearFilters === "boolean"
        ? saved.autoClearFilters : defaults.autoClearFilters,
      clinician: text("clinician"),
      consent: ["all", "signed", "not_signed", "email_bounced"].includes(saved.consent)
        ? saved.consent : defaults.consent,
      statusFilter: ["all", "Draft", "Sent For Signing", "Expired", "Completed", "Archived"].includes(saved.statusFilter)
        ? saved.statusFilter : defaults.statusFilter,
      query: text("query"),
      patientQuery: text("patientQuery"),
      selectedPatientId: Number.isSafeInteger(saved.selectedPatientId) && saved.selectedPatientId > 0
        ? saved.selectedPatientId : null,
    };
  } catch {
    return { ...defaults };
  }
}

export function saveDashboardFilters(filters: DashboardFilterState): void {
  try {
    window.sessionStorage.setItem(DASHBOARD_FILTER_STORAGE_KEY, JSON.stringify(filters));
  } catch {
    // Keep filters usable in memory when browser storage is unavailable.
  }
}
